<template>
    <!-- <div>
        <img :src="url" class="image" width="100%"/>
    </div> -->
    <div>
                                <div class="slider-box">
                                    <img :src="url" alt="">
                                </div>
                            </div>
</template>
<script>
export default {
    props:{
        url:String
    }
}
</script>
